export default {
  upTo: 'até {value}',
  kpi: 'KPI',
  restrictions: 'Restrições',
  timeRestrictions: 'Restrições de tempo',
  allChannels: 'Todos os Canais',
  fullPeriod: 'Período Completo',
  spendIn: 'Gasto em',
  and: 'e',
  unrestricted: 'Sem restrição',
  moreThan: 'Mais de',
  lessThan: 'Menos de',
  between: 'Entre',
  exactly: 'Exatamente',
  mediaSpendCalendar: 'Calendário de Investimento em Mídia ({unit})',
  kpiWeighting: 'Ponderação de KPI',
  kpiAutoBalance: 'Auto-Balance'
}
